// finishReason 'length' in assistant-message metadata means the model hit the
// output-token ceiling mid-answer (server: src/turn-finish-metadata.mjs). The
// adapter surfaces server messageMetadata at the top level of ThreadMessage
// metadata today; the `custom` fallback mirrors how the assistant-ui usage
// helper reads legacy placements, so a library upgrade cannot silently hide
// the truncation signal.
export const truncatedByLength = (metadata: unknown): boolean => {
  const record = metadata as
    | { finishReason?: unknown; custom?: { finishReason?: unknown } }
    | null
    | undefined;
  return (record?.finishReason ?? record?.custom?.finishReason) === 'length';
};
